var map = {
	"./2020/report-1.jpg": "ce9b",
	"./2020/report-10.jpg": "616d",
	"./2020/report-2.jpg": "0c52",
	"./2020/report-3.jpg": "aff7",
	"./2020/report-4.jpg": "0c32",
	"./2020/report-5.jpg": "ecdb",
	"./2020/report-6.jpg": "72e8",
	"./2020/report-7.jpg": "050c",
	"./2020/report-8.jpg": "0e94",
	"./2020/report-9.jpg": "0d10",
	"./2021/report-1.jpg": "30c0",
	"./2021/report-10.jpg": "4e94",
	"./2021/report-2.jpg": "bbc2",
	"./2021/report-3.jpg": "638e",
	"./2021/report-4.jpg": "264f",
	"./2021/report-5.jpg": "2aba",
	"./2021/report-6.jpg": "cb1b",
	"./2021/report-7.jpg": "311b",
	"./2021/report-8.jpg": "d6b7",
	"./2021/report-9.jpg": "b558",
	"./2022/report-1.jpg": "cf68",
	"./2022/report-2.jpg": "175b",
	"./2022/report-3.jpg": "8929",
	"./2022/report-4.jpg": "c742",
	"./2022/report-5.jpg": "2c79",
	"./2022/report-6.jpg": "90c5",
	"./2022/report-7.jpg": "cb89",
	"./2022/report-8.jpg": "26af",
	"./2023/report-1.jpg": "c313",
	"./2023/report-10.jpg": "e863",
	"./2023/report-2.jpg": "a2aa",
	"./2023/report-3.jpg": "905f",
	"./2023/report-4.jpg": "7448",
	"./2023/report-5.jpg": "31e9",
	"./2023/report-6.jpg": "7120",
	"./2023/report-7.jpg": "1d43",
	"./2023/report-8.jpg": "f97d",
	"./2023/report-9.jpg": "2e75",
	"./2024/report-1.jpg": "cb47",
	"./2024/report-2.jpg": "d426",
	"./2024/report-3.jpg": "82ad",
	"./2024/report-4.jpg": "377e",
	"./2024/report-5.jpg": "6f0d",
	"./2024/report-6.jpg": "f877",
	"./2024/report-7.jpg": "a82d",
	"./2024/report-8.jpg": "005c",
	"./2024/report-9.jpg": "75ed",
	"./2025/report-1.jpg": "8d9d",
	"./2025/report-10.jpg": "d37d",
	"./2025/report-11.jpg": "1e56",
	"./2025/report-12.jpg": "7402",
	"./2025/report-2.jpg": "abf3",
	"./2025/report-3.jpg": "7378",
	"./2025/report-4.jpg": "78e2",
	"./2025/report-5.jpg": "790f",
	"./2025/report-6.jpg": "fcea",
	"./2025/report-7.jpg": "e82d",
	"./2025/report-8.jpg": "ca89",
	"./2025/report-9.jpg": "66d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1b68";